import script from "./BlogDesignWebsite.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogDesignWebsite.vue?vue&type=script&setup=true&lang=js"

import "./BlogDesignWebsite.vue?vue&type=style&index=0&id=ff10ab3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff10ab3a"]])

export default __exports__